import type {
  DataBuilderListDatasetsResponse,
  DataBuilderNewDataset,
  DataBuilderUpdateDataset,
} from './data-builder-api.types';
import { DATA_BUILDER_ENDPOINTS, withUserId } from './data-builder-endpoints';
import { fetchJson } from './fetch-util';

// `userId` lets a Revelio admin view another user's datasets while impersonating
// (mirrors the `?user_id=` convention used by /status, /submit, etc.).
export const listDataBuilderDatasetsOnBackend = (
  userId?: string
): Promise<DataBuilderListDatasetsResponse> =>
  fetchJson<DataBuilderListDatasetsResponse>(
    withUserId(DATA_BUILDER_ENDPOINTS.listDatasets, userId),
    { method: 'GET' }
  );

// Create a saved dataset. The backend replies 200 with an empty body; see
// fetch-util empty-body handling.
export const createDataBuilderDatasetOnBackend = (
  input: DataBuilderNewDataset
): Promise<void> =>
  fetchJson<void>(DATA_BUILDER_ENDPOINTS.createDataset, {
    method: 'POST',
    body: JSON.stringify(input),
  });

// Update an existing saved dataset in place (name + payload), by id.
export const updateDataBuilderDatasetOnBackend = (
  input: DataBuilderUpdateDataset
): Promise<void> =>
  fetchJson<void>(DATA_BUILDER_ENDPOINTS.updateDataset, {
    method: 'POST',
    body: JSON.stringify(input),
  });

export const deleteDataBuilderDatasetOnBackend = (id: string): Promise<void> =>
  fetchJson<void>(DATA_BUILDER_ENDPOINTS.deleteDataset, {
    method: 'POST',
    body: JSON.stringify({ id }),
  });
